import React from "react";
import {Link} from "gatsby";
import { Container } from "react-bootstrap";
//import Slider from "react-slick";

import {Carousel} from "@dadoagency/gatsby-plugin-trustpilot-widget";

import {PageLinks} from "../../common/page-links";
import Trustp_Logo from "../../images/trustpilot_logo.png";
import ContentModule from "../../modules/content_module";


import "./TrustpilotReviews.scss";

const TrustpilotReviews = ({ Module }) => { 

    //console.log("Module", Module);

    // var settings = {
    //     dots: false,
    //     arrows: true,
    //     infinite: false,
    //     speed: 500,
    //     slidesToShow: 1,
    //     slidesToScroll: 1,
    //     mobileFirst: true,
    //     autoplay:true,
    //     autoplaySpeed:3000
    // };

    const ref = React.useRef(null);
    React.useEffect(() => {
        //console.log("ref_current", ref.current.children[0])
        if(Module?.content){
            if(ref?.current?.children?.length > 0){
                if (window.Trustpilot) {
                    window.Trustpilot.loadFromElement(ref.current.children[0], true);
                }
            }
        }
    }, [Module]);


    return (
        <React.Fragment>           
            <section className="trustpilot_wrapper">
                
                {(Module?.bg_image?.url) ?
                <Container>
  
                        <div style={{backgroundImage:`url(${Module?.bg_image?.url})`}}  className={"bg_img"}>

                            <span className="gradient_bg"></span>

                            <div className="trustpilot_cnt">
                                <img src={Trustp_Logo} alt="Trustpilot" className="trust_logo" />
                                <h2>{Module.title}</h2>
                                <p>{Module.content}</p>

                                <div className="trust_inner">
                                    <div className="left_side">
                                        
                                        <div className="desktop_tab_view">
                                            <Carousel 
                                                language="en"
                                                culture="US"
                                                theme="dark"
                                                width="94%"
                                                height="140px"
                                                stars="4,5"
                                            />
                                        </div>
                                        <div className="mobile_view">
                                            <Carousel 
                                                language="en"
                                                culture="US"
                                                theme="dark"
                                                width="100%"
                                                height="140px"
                                                stars="4,5"
                                            />
                                        </div>
                                        <div className="small_mobile_view">
                                            <Carousel 
                                                language="en"
                                                culture="US"
                                                theme="dark"
                                                width="100%"
                                                height="300px"
                                                stars="4,5"
                                            />
                                        </div>                                        
                                    </div>

                                    
                                    {/* <div className="right_side img-zoom">
                                        <img src={Trustp_Rating} alt="Trustpilot" className="trust_rating" />
                                    </div> */}
                                    {PageLinks?.reviews && 
                                        <Link to={`/${PageLinks.reviews}/`} className="btn">More Reviews</Link>
                                    }
                                </div>
                            </div>
                    </div>

                </Container>
                :
                <Container>
                    {/* {Module?.content && <ContentModule Content={Module?.content} /> } */}
                    <div ref={ref} className="trustpilot_slider">
                        {/* <div class="trustpilot-widget" data-locale="en-GB" data-template-id="54ad5defc6454f065c28af8b" data-businessunit-id="5e97c153042bf90001563220" data-style-height="240px" data-style-width="100%" data-theme="light" data-stars="5" data-review-languages="en" data-font-family="Open Sans" data-text-color="#001F37">
                                <a href="https://uk.trustpilot.com/review/johnshepherd.com" target="_blank" rel="noopener">Trustpilot</a>
                            </div> */}

                        {Module?.content && <ContentModule Content={Module?.content} /> }
                    </div>
                </Container>
                }
            </section>
        </React.Fragment>
    );
};
export default TrustpilotReviews;
